import { Component } from '@angular/core';
import { NavController, NavParams, ViewController } from 'ionic-angular';
import { Machine, GymDataService } from "../../services/gym-data.service";

/**
 * XpPickMachinePage - bottom-sheet-style modal that lists every gym machine
 * for the demo / no-QR fallback. Opened from XpSearchUnitPage when the user
 * taps "¿Sin código? Elegí la máquina". Mirrors the web/ #sheet UX.
 */
@Component({
  selector: 'page-xp-pick-machine',
  templateUrl: 'xp-pick-machine.html',
})
export class XpPickMachinePage {

  machines: Machine[] = [];
  filter: string = '';

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    public viewCtrl: ViewController,
    public gymData: GymDataService
  ) {
    let list = this.navParams.get('machines');
    if (list && list.length) { this.machines = list; }
  }

  /** Map muscleGroup slug id -> display name (synchronous lookup). */
  muscleGroupName(id: string): string {
    if (!id) { return ''; }
    let groups = this.gymData.muscleGroups();
    for (let i = 0; i < groups.length; i++) {
      if (groups[i].id === id) { return groups[i].name; }
    }
    return id;
  }

  /** Map equipment slug id -> display name (synchronous lookup). */
  equipmentName(id: string): string {
    if (!id) { return ''; }
    let eq = this.gymData.equipmentBy(id);
    return eq ? eq.name : id;
  }

  filtered(): Machine[] {
    let q = String(this.filter || '').toLowerCase().trim();
    if (!q) { return this.machines; }
    let out: Machine[] = [];
    for (let i = 0; i < this.machines.length; i++) {
      let m = this.machines[i];
      let hay = ((m.name || '') + ' ' + (m.muscleGroup || '') + ' ' + (m.equipment || '')).toLowerCase();
      if (hay.indexOf(q) >= 0) { out.push(m); }
    }
    return out;
  }

  choose(m: Machine): void {
    this.viewCtrl.dismiss(m);
  }

  cancel(): void {
    this.viewCtrl.dismiss(null);
  }
}



// WEBPACK FOOTER //
// ./src/pages/xp-pick-machine/xp-pick-machine.ts